/**
 * Cart event utilities for Magento integration
 *
 * Dispatches DOM events that Magento's customer-data system listens for,
 * then redirects to the cart page.
 */

/**
 * Notify Magento cart section and redirect to cart page
 */
export function dispatchCartRefreshEvent(): void {
  document.dispatchEvent(new CustomEvent('customEventReload', {
    detail: ['cart'],
  }));
  window.location.assign('/checkout/cart');
}
